import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik, Formik,  Field, FieldArray, FormikProvider } from "formik";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';

import {
    getFeatureFileTypes as onGetFeatureFileTypes,
    addNewFeatureFileType as onAddNewFeatureFileType,
    updateFeatureFileType as onUpdateFeatureFileType,
    deleteFeatureFileType as onDeleteFeatureFileType,

    getFileTypes as onGetFileTypes,
    getFeatures as onGetFeatures,

} from "store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const FeatureFileType = () => {

    //meta title
    document.title = "Fonctionalités/Types de fichiers | CinzanEdu";

    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [featureFileType, setFeatureFileType] = useState(null);
    
    
   


 

    // validation
    const validation = useFormik({
  enableReinitialize: true,

  initialValues: {
    id: featureFileType?.id,
    feature_id: featureFileType?.feature_id
      ? String(featureFileType.feature_id)
      : "",
    items: featureFileType?.items?.length
      ? featureFileType.items.map(item => ({
          file_type_id: String(item.file_type_id),
          required: Boolean(item.required),
        }))
      : [{ file_type_id: "", required: false }],
  },

  validationSchema: Yup.object({
    feature_id: Yup.string().required("Veuillez sélectionner une fonctionnalité"),
    items: Yup.array()
      .of(
        Yup.object({
          file_type_id: Yup.string().required("Type de fichier requis"),
          required: Yup.boolean(),
        })
      )
      .min(1, "Au moins un type de fichier est requis"),
  }),

  onSubmit: (values) => {
    const payload = {
        id: featureFileType?.id, // 🔥 OBLIGATOIRE
      feature_id: Number(values.feature_id),
      items: values.items.map(item => ({
        file_type_id: Number(item.file_type_id),
        required: item.required,
      })),
    };

    if (isEdit) {
      dispatch(onUpdateFeatureFileType(payload));
    } else {
      dispatch(onAddNewFeatureFileType(payload));
    }

    validation.resetForm();
    toggle();
  },
});



    const dispatch = useDispatch();

    const FreatureFileTypeProperties = createSelector(
        (state) => state.featureFileTypeReducer, 
        (featureFileTypeReducer) => ({
            featureFileTypes: featureFileTypeReducer.featureFileTypes,
            loading: featureFileTypeReducer.loading
        })
    );

    const {featureFileTypes, loading} = useSelector(FreatureFileTypeProperties);

    const [isLoading, setLoading] = useState(loading)

    
    /*
    useEffect(() => {
        if (featureFileTypes && !featureFileTypes.length) {
            dispatch(onGetFeatureFileTypes());
        }
    }, [dispatch, featureFileTypes]);
    */
   useEffect(() => {
    if (!featureFileTypes.length) {
        dispatch(onGetFeatureFileTypes());
    }
}, [dispatch]);



    // File types
    const FileTypeProperties = createSelector(
        (state) => state.fileTypeReducer, 
        (fileTypeReducer) => ({
            fileTypes: fileTypeReducer.fileTypes,
            loading: fileTypeReducer.loading
        })
    );

    const {fileTypes} = useSelector(FileTypeProperties);



    /*
    useEffect(() => {
        if (fileTypes && !fileTypes.length) {
            dispatch(onGetFileTypes());
        }
    }, [dispatch, fileTypes]);
    */
   useEffect(() => {
    if (!fileTypes.length) {
        dispatch(onGetFileTypes());
    }
}, [dispatch]);


     // Features
    const FeatureProperties = createSelector(
        (state) => state.featureReducer, 
        (featureReducer) => ({
            features: featureReducer.features,
            loading: featureReducer.loading
        })
    );

    const {features} = useSelector(FeatureProperties);


    /*
    useEffect(() => {
        if (features && !features.length) {
            dispatch(onGetFeatures());
        }
    }, [dispatch, features]);
    */

    useEffect(() => {
    if (!features.length) {
        dispatch(onGetFeatures());
    }
}, [dispatch]); // <-- features retiré


    const toggle = () => {
        if (modal) {
            setModal(false);
            setFeatureFileType(null);
        } else {
            setModal(true);
        }
    };

    const handleFeatureFileTypeClick = (featureFileType) => {
    setFeatureFileType({
        id: featureFileType.id,
        uid: featureFileType.uid,
        feature_id: featureFileType.feature_id,
        items: featureFileType.items || [], 
    });

    setIsEdit(true);
    toggle();
    };

    /* Option 2 la meilleur
    const handleFeatureFileTypeClick = (row) => {
    dispatch(onGetFeatureFileType(row.id)); // GET /feature-file-types/{id}
    setIsEdit(true);
    toggle();
    }; */


    //delete Serial movie
    const [deleteModal, setDeleteModal] = useState(false);

    const onClickDelete = (branch) => {
        setFeatureFileType(branch);
        setDeleteModal(true);
    };

    const handleDeleteFeatureFileType = () => {
        if (featureFileType && featureFileType.id) {
            //dispatch(onDeleteSerialeventCategory(serialeventCategory.id));
            dispatch(onDeleteFeatureFileType(featureFileType));
            setDeleteModal(false);
        }
    };

    const onClickNewFeatureFileType = () => {
        setIsEdit(false);
        setFeatureFileType(null);
        toggle();
        //setModal(true)
    };

    const columns = useMemo(
        () => [
            {
                header: 'ID',
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Fonctionalité",
                accessorKey: "feature.name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            
           
            
            
            
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        handleFeatureFileTypeClick(jobData);
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                        Edit
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        //console.log("ON DELETE: ", jobData);
                                        onClickDelete(jobData);
                                    }}
                                    id={`deletetooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-delete-outline" />
                                    <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id}`}>
                                        Delete
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                        </ul>
                    );
                }
            },
        ],
        []
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteFeatureFileType}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Fonctionalités/Types de fichiers" breadcrumbItem="Liste des fonctionalités/Types de fichiers" />
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 
                                                <div className="flex-shrink-0">
                                                    <Link to="#!" onClick={onClickNewFeatureFileType} className="btn btn-primary me-1">Ajouter </Link>
                                                    
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={featureFileTypes || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={true}
                                                //isJobListGlobalFilter={false}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                      
                        
                                                
                                                //tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }
                    <Modal
                        key={featureFileType?.id || "create"}
                        isOpen={modal}
                        toggle={toggle}
                        backdrop="static"
                        size="md"
>
                        <ModalHeader toggle={toggle} tag="h4">
                            {!!isEdit
                            ? "Modifier - Type de fichier"
                            : "Ajouter - Type de fichier"}
                        </ModalHeader>

                        <ModalBody>
                            <FormikProvider value={validation}>
                            <Form
                            onSubmit={(e) => {
                                e.preventDefault();
                                validation.handleSubmit();
                                return false;
                            }}
                            >
                            <Row>
                                <Col md="12">

                                {/* ================= Feature ================= */}
                               <div className="mb-3">
                                    <Label>Fonctionnalité</Label>
                                    <Input
                                        type="select"
                                        className="form-select"
                                        value={validation.values.feature_id}
                                        onChange={(e) =>
                                        validation.setFieldValue("feature_id", e.target.value)
                                        }
                                        invalid={
                                        validation.touched.feature_id &&
                                        !!validation.errors.feature_id
                                        }
                                    >
                                        <option value="">-- Sélectionner --</option>
                                        {features.map(f => (
                                        <option key={f.id} value={String(f.id)}>
                                            {f.name}
                                        </option>
                                        ))}
                                    </Input>

                                    <FormFeedback>
                                        {validation.errors.feature_id}
                                    </FormFeedback>
                                    </div>


                                <hr />

                                {/* ================= Nested Items ================= */}
                                <FieldArray name="items">
                                {({ push, remove }) => (
                                    <>
                                    <Label className="mb-2">Types de fichiers</Label>

                                    {validation.values.items.map((item, index) => (
                                        <Row key={index} className="align-items-center mb-2">
                                        
                                        {/* Select file type */}
                                        <Col md="6">
                                            <Input
                                            type="select"
                                            className="form-select"
                                            value={item.file_type_id}
                                            onChange={(e) =>
                                                validation.setFieldValue(
                                                `items.${index}.file_type_id`,
                                                e.target.value
                                                )
                                            }
                                            invalid={
                                                validation.touched.items?.[index]?.file_type_id &&
                                                !!validation.errors.items?.[index]?.file_type_id
                                            }
                                            >
                                            <option value="">Type de fichier</option>
                                            {fileTypes.map(ft => (
                                                <option key={ft.id} value={String(ft.id)}>
                                                {ft.name}
                                                </option>
                                            ))}
                                            </Input>

                                            <FormFeedback>
                                            {validation.errors.items?.[index]?.file_type_id}
                                            </FormFeedback>
                                        </Col>

                                        {/* Required checkbox */}
                                        <Col md="3">
                                            <div className="form-check mt-2">
                                            <Input
                                                type="checkbox"
                                                className="form-check-input"
                                                checked={item.required}
                                                onChange={(e) =>
                                                validation.setFieldValue(
                                                    `items.${index}.required`,
                                                    e.target.checked
                                                )
                                                }
                                            />
                                            <Label className="form-check-label">
                                                Obligatoire
                                            </Label>
                                            </div>
                                        </Col>

                                        {/* Remove */}
                                        <Col md="3" className="text-end">
                                            {validation.values.items.length > 1 && (
                                            <Button
                                                color="danger"
                                                size="sm"
                                                type="button"
                                                onClick={() => remove(index)}
                                            >
                                                Supprimer
                                            </Button>
                                            )}
                                        </Col>
                                        </Row>
                                    ))}

                                    <Button
                                        type="button"
                                        color="secondary"
                                        size="sm"
                                        onClick={() =>
                                        push({ file_type_id: "", required: false })
                                        }
                                    >
                                        Ajouter un fichier
                                    </Button>
                                    </>
                                )}
                                </FieldArray>


                                </Col>
                            </Row>

                            <Row className="mt-4">
                                <Col>
                                <div className="text-end">
                                    <Button
                                    color="primary"
                                    type="submit"
                                    className="save-user"
                                    >
                                    {!!isEdit ? "Modifier" : "Enregistrer"}
                                    </Button>
                                </div>
                                </Col>
                            </Row>
                            </Form>
                            </FormikProvider>
                        </ModalBody>
                    </Modal>

                </div>
            </div>
            <ToastContainer />
        </React.Fragment>
    );
}


export default FeatureFileType;